import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Spinner } from "reactstrap";
import MetaTags from "react-meta-tags";
const SpinnerCustom = () =>{

    const [t, i18n] = useTranslation();
    return(
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Monsta Scan</title>
                </MetaTags>
                <div className="container-fluid"></div>
             <div className="p-3 text-center">
            <Row>
                <Col lg={12} className="align-self-center">
                    <Spinner color={"success"}  />
                </Col>
            </Row>
            <Row>
            <Col lg={12} className="align-self-center">
                    {t("Loading")}
                </Col>
            </Row>
            </div>

            </div>
            </React.Fragment>
    )
    
}

export default SpinnerCustom